import { Highlighter } from 'react-bootstrap-typeahead';

import { loadRecurrenceDefinitionsLOV } from 'api/recurrence_definitions/operations/loadRecurrenceDefinitionsLOV';

import { EditReference } from './EditReference';

// The minimal identifying shape this control deals in.
// `RecurrenceDefinitionSummary` from the endpoint is structurally
// assignable to this, so the loader passes straight through.
export interface RecurrenceDefinitionReference {
  readonly recurrence_definition_id: number;
  readonly name: string;
  readonly zone_name: string;
}

interface Props {
  readonly value: RecurrenceDefinitionReference | null;
  readonly onChange: (value: RecurrenceDefinitionReference | null) => void;
  readonly label?: string;
  readonly mandatory?: boolean;
  readonly disabled?: boolean;
}

const getKey = (r: RecurrenceDefinitionReference) => r.recurrence_definition_id;

const getLabel = (r: RecurrenceDefinitionReference): string => r.name;

/**
 * Searchable dropdown for RecurrenceDefinitions. Two-column menu
 * (name + zone, muted right-aligned as informational context). The
 * search only matches on name.
 */
export const EditRecurrenceDefinitionReference = ({ value, onChange, label = 'Recurrence Definition', mandatory, disabled }: Props) => (
  <EditReference<RecurrenceDefinitionReference>
    label={label}
    value={value}
    onChange={onChange}
    source={loadRecurrenceDefinitionsLOV}
    getKey={getKey}
    getLabel={getLabel}
    mandatory={mandatory}
    disabled={disabled}
    renderMenuItemChildren={(r, query) => (
      <div className="d-flex justify-content-between gap-3">
        <span>
          <Highlighter search={query}>{r.name}</Highlighter>
        </span>
        <span className="text-body-secondary">{r.zone_name}</span>
      </div>
    )}
  />
);
